import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-42ab6d07")
const _hoisted_1 = {
  key: 0,
  class: "content"
}
const _hoisted_2 = { id: "account-selection" }
const _hoisted_3 = { class: "section" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", { class: "heading" }, "Select your accounts", -1)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "Please select the accounts you would like to share data from.", -1)
const _hoisted_8 = { class: "section error" }
const _hoisted_9 = { class: "info-panel" }
const _hoisted_10 = { style: {"padding":"10px"} }
const _hoisted_11 = {
  class: "section button-bar",
  style: {"text-align":"center"}
}
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ListAccounts = _resolveComponent("ListAccounts")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.applicationStore.consentRequest)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              (
            _ctx.applicationStore.consentRequest?.existingArrangement
              ?.attachedAccounts
          )
                ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.applicationStore.consentRequest.recipient.clientName) + " is requesting to amend access to your data. The selected accounts are already being shared under a prior sharing arrangement. ", 1))
                : (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.applicationStore.consentRequest.recipient.clientName) + " is requesting your data. ", 1)),
              _hoisted_7
            ]),
            _createVNode(_component_ListAccounts, {
              accounts: _ctx.applicationStore.allAccounts,
              selected: _ctx.applicationStore.selectedAccounts,
              selectable: "",
              onChange: _ctx.updateSelectedAccounts
            }, null, 8, ["accounts", "selected", "onChange"])
          ]),
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.errorMessage), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("button", {
            name: "submit",
            class: "medium so-primary-1",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.submit())),
            style: {"min-width":"120px"}
          }, " Continue "),
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              name: "cancel",
              class: "medium so-secondary-1",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.cancel())),
              style: {"min-width":"120px"}
            }, " Cancel ")
          ])
        ])
      ])
    ])
  ], 64))
}